import React from 'react';

const Checkout = () => {
    return (
        <div>
            <h3>This Checkout Page</h3>
        </div>
    );
};

export default Checkout;